module.exports = __webpack_public_path__ + "img/cooperate_yh_05@2x.fadbc6c9.png";